import api from './api';

/**
 * REV-491: the subject-access export.
 *
 * The response is a JSON *file*, not the usual {success, data} envelope, so it
 * is fetched as a blob and handed straight to the browser. Parsing it here
 * only to re-serialise it would risk mangling the document the user is
 * entitled to receive verbatim.
 */
export const userDataService = {
  async getExport(): Promise<Blob> {
    const res = await api.get<Blob>('/v1/users/me/export', { responseType: 'blob' });
    return res.data;
  },
};

export default userDataService;
